var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Providers/index.tsx";
import React from 'react';
import { ParallaxProvider, config } from '@adc/parallax-component-library';
import { useTheme } from 'Hooks';
const Providers = ({
  children
}) => {
  const {
    theme
  } = useTheme();
  const defaultTheme = theme.endsWith('Dark') ? 'dark' : 'light';
  return /*#__PURE__*/React.createElement(ParallaxProvider, {
    config: config,
    locale: "en-US",
    dir: "ltr",
    defaultTheme: defaultTheme,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, children);
};
export default Providers;